export default __webpack_public_path__ + "static/media/bg-img.56eec95b.png";